var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolicy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    id: "SVGRoot",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 1.17849
    },
    d: "M 80.106435,121.65808 C 68.437933,124.62502 55.922247,88.348685 62.421613,79.533879 c 4.131792,-5.603776 41.443657,14.174118 57.418607,28.229101 58.64761,51.599 60.02657,240.7075 35.72483,304.88985 -10.4244,27.53146 -7.09293,55.11844 3.05728,72.92587 12.3945,21.74489 33.98672,28.76882 41.00512,1.57251 5.88181,-22.79207 -15.95307,-43.73948 -23.73037,-42.64119 -9.10258,1.28545 -4.55513,27.60609 1.68914,38.65183 1.80546,-17.81462 -4.93244,-32.03256 2.89227,-29.12233 19.12621,7.11351 14.83441,34.49822 7.01844,42.92001 -5.58889,6.0221 -18.05667,-3.96551 -22.37747,-11.00514 -10.07456,-16.41389 -19.35274,-28.04994 1.65002,-84.98512 4.72481,-12.80822 12.33075,-49.59585 12.70577,-87.11695 C 180.4143,219.89862 154.21269,97.308113 91.392031,76.574081 78.21483,72.22493 62.108952,67.908927 53.950019,74.337387 c -6.411493,5.051634 -7.848438,19.828911 -1.059635,30.600353 14.767487,23.43083 27.736589,32.50322 35.662716,23.2947 13.54131,-15.73218 0.185761,-31.663189 -11.797979,-39.618396 8.890951,14.894126 17.079607,29.553366 3.351314,33.044036 z",
    id: "path985"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 1.17849
    },
    d: "m 300.73683,16.641443 c 4.13179,-5.60377 41.79628,14.94987 57.77123,29.004852 58.6476,51.599006 60.02657,240.707515 35.72482,304.889855 -10.4244,27.53146 -7.09292,55.11844 3.05727,72.92586 12.39452,21.7449 33.98674,28.76884 41.00513,1.57252 5.88181,-22.79207 -15.95307,-43.73948 -23.73036,-42.64119 -8.53842,2.76643 -3.42677,2.92317 -14.24897,6.70509 12.03123,-2.15857 11.00566,-0.0858 18.83038,2.8244 19.1262,7.11352 14.83439,34.49823 7.01844,42.92002 -5.58889,6.0221 -18.05668,-3.96551 -22.37747,-11.00514 -10.07456,-16.41389 -19.35275,-28.04994 1.65001,-84.98513 4.72482,-12.80821 12.33076,-49.59584 12.70577,-87.11694 0.93905,-93.95371 -25.26255,-216.544207 -88.08322,-237.278249 -13.1772,-4.349152 -27.73158,-9.3351148 -37.442,-2.236694 3.0222,2.187841 5.376,2.9983 8.11897,4.420746 z",
    id: "path985-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 1.17314
    },
    d: "m 184.76131,504.78598 242.2597,-62.74206 -2.38287,-5.95654 -240.27398,62.74208 z",
    id: "path1058"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 1.17849
    },
    d: "m 175.09287,444.68945 239.81453,-62.33503 6.56378,2.9865 -236.47971,64.28537 z",
    id: "path1060"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 1.17849
    },
    d: "m 177.48649,483.01225 c 0,0 20.69481,-5.23604 20.69481,-5.48538 0,-0.24933 -1.79522,-8.07845 -1.79522,-8.07845 l -19.99667,5.03657 z",
    id: "path1064"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 1.17849
    },
    d: "m 76.759053,88.630496 17.57776,-4.866057 4.407667,6.611499 -14.986058,3.949255 z",
    id: "path1066"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 1.17849
    },
    d: "m 82.101141,131.63165 50.116479,-14.49538 -2.78045,-3.527 -47.495881,13.80131 z",
    id: "path1068"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 1.17849
    },
    d: "M 62.002198,71.405348 300.41014,9.0434078 309.06904,14.908883 69.038442,73.289232 Z",
    id: "path1796"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 1.17849
    },
    d: "m 138.98915,81.832137 7.97873,10.372338 154.38825,-47.473399 -4.78722,-9.574466 z",
    id: "path1798"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 1.17849
    },
    d: "m 164.92,125.33482 7.18085,10.77126 180.31912,-61.037207 -7.18085,-11.569145 z",
    id: "path1800"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 1.17849
    },
    d: "m 181.27639,161.8717 6.38296,13.96276 180.31913,-62.63296 -6.78193,-11.96809 z",
    id: "path1802"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 1.17849
    },
    d: "m 191.24978,194.14888 3.59042,14.76064 116.88829,-36.3032 -5.58511,-14.36169 z",
    id: "path2565"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 1.17849
    },
    d: "m 198.43063,230.85099 2.39361,15.95745 183.90955,-51.86169 -3.98935,-16.35637 z",
    id: "path2567"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9ddaf",
      strokeWidth: 0.56418
    },
    d: "m 92.485142,123.14361 c 3.715607,-8.92369 1.953217,-17.41448 -5.400289,-26.017348 -1.1986,-1.402232 -2.115575,-2.613219 -2.037723,-2.691069 0.07785,-0.0779 2.504261,-0.773852 5.39202,-1.546667 l 5.250472,-1.405119 6.704498,4.168924 c 7.94253,4.938749 16.56776,11.464679 20.66472,15.635119 l 2.94602,2.99887 -13.10127,3.80715 c -22.714733,6.60076 -20.874591,6.14565 -20.418448,5.05014 z",
    id: "path4159"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9ddaf",
      strokeWidth: 0.56418
    },
    d: "m 74.317878,119.71255 c -3.961853,-2.86996 -8.037054,-10.07293 -11.211274,-19.816072 -1.337123,-4.104237 -1.569996,-5.782706 -1.615462,-11.643663 -0.0625,-8.056344 0.485616,-9.231022 4.307244,-9.231022 2.636976,0 9.168769,2.118102 15.06649,4.885702 l 4.268737,2.003165 -4.231357,1.25379 c -2.536765,0.75166 -4.171699,1.528223 -4.082393,1.939042 0.08193,0.37688 0.781824,1.687755 1.555319,2.913061 2.458768,3.894938 6.893399,13.129567 7.82946,16.303987 1.2524,4.24721 1.145046,6.84473 -0.377049,9.12316 -2.690842,4.02795 -7.714339,5.0182 -11.509715,2.26885 z",
    id: "path4161"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9ddaf",
      strokeWidth: 0.56418
    },
    d: "m 180.34117,497.93479 c -7.47991,-2.29399 -14.57373,-9.99544 -20.98726,-22.78495 -3.58388,-7.14678 -4.68097,-11.94356 -4.72649,-20.6657 -0.0681,-13.05757 3.21671,-27.56141 11.43597,-50.49419 5.38222,-15.0171 9.68077,-37.40908 12.56333,-65.44497 1.12423,-10.9343 0.93235,-54.20656 -0.30521,-68.83006 C 173.4048,211.61714 162.28615,165.68987 144.58648,130.36727 136.43823,114.10611 128.53767,102.90881 118.2353,93.020363 107.61757,82.829205 97.806057,77.530115 81.997632,73.448798 L 76.040748,71.9109 190.32034,44.136995 c 62.8538,-15.275647 114.83573,-27.766113 115.5154,-27.75659 2.15936,0.03025 9.23795,2.828733 17.1001,6.760411 11.28802,5.644886 22.23168,12.462089 31.3408,19.523337 19.72607,15.291337 34.46477,44.680593 43.98056,87.698097 11.76655,53.19232 13.80828,126.82761 5.03566,181.61117 -2.20639,13.77854 -4.58257,23.70679 -8.72671,36.46214 -5.05361,15.55468 -6.16979,20.96884 -6.57636,31.89911 l -0.32679,8.78512 -106.13022,27.53353 c -58.37163,15.14345 -106.76494,27.96915 -107.54068,28.50157 -2.1469,1.47346 -3.00458,3.79729 -3.27618,8.8767 -0.40906,7.64965 1.84169,19.05471 5.22956,26.49948 l 1.32675,2.91551 8.23311,-2.16878 c 5.44302,-1.43381 8.22976,-1.94385 8.2233,-1.50506 -0.033,2.23156 -1.87349,8.80042 -3.30737,11.80387 -2.85869,5.98795 -5.6161,7.72724 -10.0801,6.35818 z M 292.65526,221.24522 c 50.52551,-14.24632 91.97454,-26.01237 92.10895,-26.14677 0.2574,-0.25742 -3.46232,-16.14929 -3.87705,-16.56402 -0.20939,-0.20937 -181.98994,51.62385 -182.57461,52.05965 -0.25638,0.19109 2.11581,16.55368 2.39988,16.55358 0.043,-4e-5 41.41731,-11.65612 91.94283,-25.90244 z M 253.5416,191.02758 c 31.80568,-9.85776 57.98677,-18.0831 58.18017,-18.27853 0.29296,-0.29602 -4.77911,-13.99775 -5.41823,-14.63687 -0.26087,-0.26089 -114.4082,35.41468 -114.91287,35.91483 -0.56741,0.56229 3.10785,15.36436 3.75646,15.12907 0.31125,-0.1129 26.58877,-8.27074 58.39447,-18.1285 z m 24.07172,-46.06981 c 49.28589,-17.10672 89.83658,-31.30876 90.11264,-31.56008 0.37283,-0.33944 -4.81741,-10.61779 -6.21846,-12.31454 -0.10163,-0.12308 -40.78158,13.45665 -90.39989,30.17717 -84.78111,28.56978 -90.18828,30.46931 -89.76955,31.53582 1.0457,2.66344 6.16231,13.26476 6.40211,13.26476 0.14432,0 40.58725,-13.99641 89.87315,-31.10313 z M 294.4447,95.073424 c 31.96084,-10.799998 58.18918,-19.691156 58.2852,-19.758129 0.21012,-0.146558 -6.01055,-10.373867 -6.93677,-11.404637 -0.5213,-0.580146 -18.40631,5.364553 -89.75217,29.832234 -49.00562,16.806218 -89.67682,30.773788 -90.38044,31.039048 -1.2476,0.47033 -1.18666,0.62146 2.45859,6.09642 l 3.73792,5.61414 32.23852,-10.89135 c 17.73119,-5.99025 58.38831,-19.72773 90.34915,-30.527726 z M 224.02808,68.84219 c 42.42781,-13.045968 77.26317,-23.841654 77.41193,-23.990412 0.32147,-0.321465 -3.96031,-9.247342 -4.63644,-9.665213 -0.64442,-0.398276 -157.79069,46.19598 -157.79069,46.785328 0,0.404374 7.38063,10.465155 7.7451,10.557608 0.0707,0.01791 34.84231,-10.641339 77.2701,-23.687311 z",
    id: "path4163"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9ddaf",
      strokeWidth: 0.56418
    },
    d: "m 197.4474,494.30217 c 6.23876,-15.01651 3.76459,-28.46184 -7.69288,-41.80514 l -2.67515,-3.11548 100.38813,-27.28376 c 55.21348,-15.00608 100.4594,-27.18676 100.54646,-27.06821 0.0871,0.11857 0.48604,2.24661 0.8866,4.72901 2.4809,15.37462 9.83211,29.78421 19.01157,37.26588 l 2.88799,2.35383 -38.14928,9.96366 c -20.98213,5.48002 -69.06963,18.03804 -106.86116,27.9067 -51.11416,13.34768 -68.61719,17.71523 -68.34228,17.05351 z",
    id: "path4165"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9ddaf",
      strokeWidth: 0.56418
    },
    d: "m 177.47408,465.25839 c -0.77568,-9.81636 -0.60477,-11.05862 1.5204,-11.05104 2.02601,0.008 6.82668,2.849 9.00606,5.33118 1.9341,2.20283 4.22479,6.4295 4.81586,8.88601 0.4123,1.7135 1.2447,1.35476 -9.27141,3.99575 l -5.39787,1.35564 z",
    id: "path4167"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e9ddaf",
      strokeWidth: 0.56418
    },
    d: "m 416.06518,434.65182 c -4.48695,-2.23592 -9.75714,-7.4991 -13.40884,-13.39096 -6.02121,-9.71501 -8.52788,-16.28092 -9.41774,-24.66859 l -0.33593,-3.16634 8.94984,-2.41112 8.94985,-2.41112 6.46949,2.92413 c 6.98654,3.15782 10.03251,5.64613 12.29182,10.04145 3.936,7.65715 3.71508,19.12942 -0.54003,28.04522 -3.17799,6.65887 -6.84439,8.08411 -12.95846,5.03733 z",
    id: "path4169"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 1.17849
    },
    d: "m 204.41467,276.4196 v 19.56793 l 186.7021,-51.8617 -0.83798,-17.54488 z",
    id: "path4225"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 1.17849
    },
    d: "m 203.61681,318.40124 -3.1915,19.14893 188.29784,-47.07446 2.62731,-19.70481 z",
    id: "path4227"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 1.17849
    },
    d: "m 199.09814,354.05996 -3.94927,14.10451 105.78391,-23.13141 3.66717,-16.07916 z",
    id: "path4229"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      strokeWidth: 1.17849
    },
    d: "m 192.04589,384.44411 -5.07763,13.25826 175.74233,-34.97921 6.77017,-15.51498 z",
    id: "path4231"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy);
export default __webpack_public_path__ + "static/media/policy.d604da2e7951496e94e896f364650c2c.svg";
export { ForwardRef as ReactComponent };